import Component from './WexComponent';

export default class {
    static getPageLevelMixins() {
        return {};
    }

    constructor(app, data) {
        this.app = app;

        if (data.main) {
            this.app.pageMain = this;
        }

        // TODO Only support single page for now.
        // this.el = document.getElementById('main');
        this.el = document.body;

        this.init(data);
    }

    loadData(data) {
        // No action for now.
    }

    init(data) {
        this.loadData(data);

        this.app.mixin.invokeUntilComplete('init', 'page', [data]);
    }

    initComponent(elSelector, componentDefinition, options) {
        return new Component(
            this,
            componentDefinition,
            // Support passing objects.
            typeof elSelector === 'string'
                ? document.querySelector(elSelector)
                : elSelector,
            options
        );
    }
}
